import { useMutation } from '@tanstack/react-query'
import { confirmPasswordReset } from '@/services/api/auth'

const CONFIRM_PASSWORD_RESET_MUTATION_KEY = ['mutation', 'auth', 'confirmPasswordReset'] as const

interface ConfirmPasswordResetVars {
  token: string
  password: string
  passwordConfirmation: string
}

/** Confirms a password reset with the emailed token. Not offline-replayable. */
export function useConfirmPasswordReset() {
  return useMutation({
    mutationKey: CONFIRM_PASSWORD_RESET_MUTATION_KEY,
    mutationFn: ({ token, password, passwordConfirmation }: ConfirmPasswordResetVars) =>
      confirmPasswordReset(token, password, passwordConfirmation),
  })
}
